import React, { useContext } from 'react';

import RouterFactory from '../../../../routing/child-router-factory';

import { routingMap } from '../../../../routing/routing-map';

import { createConfig } from './route-config';

import { RouterContext } from '../../../../context/routing';

export { createRoutesMap } from './route-config';

function Collections() {
  const routing = useContext(RouterContext);

  const routeMap: typeof routingMap = routing?.routingMap;

  return (
    <RouterFactory
      config={createConfig(routeMap)}
      basePath={routeMap.app.collections._}
      defaultRedirect={routeMap.app.collections._}
    />
  );
}

export default Collections;
